import { IColors, ITheme } from "@swiggy-private/dls-web-common/dist/components/types";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled, { css, keyframes } from "styled-components";

const TICKER_TEXT_CONFIGS = {
    WIDTH: "36px",
    HEIGHT: "60px",
    FONT_SIZE: 60,
    FONT_WEIGHT: 900,
    LINE_HEIGHT: "60px",
};

const PUNCTUATION_TEXT_DIMENSIONS = {
    WIDTH: "16px",
    HEIGHT: "60px",
};

const getTextColor = (tickerTextColor?: keyof IColors, theme?: ITheme) => {
    if (!theme) {
        return "#C8F9E5"; // hex code for positive_Sub
    }

    if (!tickerTextColor) {
        return theme.colors[theme.colorMode].positive_Sub;
    }

    return theme.colors[theme.colorMode][tickerTextColor];
};

export const TickerText = styled(Text)<{
    isRewardRedeemed: boolean;
    shouldAnimate?: boolean;
    tickerTextColor?: keyof IColors;
}>`
    font-size: ${TICKER_TEXT_CONFIGS.FONT_SIZE}px;
    font-weight: ${TICKER_TEXT_CONFIGS.FONT_WEIGHT};
    line-height: ${TICKER_TEXT_CONFIGS.LINE_HEIGHT};
    height: ${TICKER_TEXT_CONFIGS.HEIGHT};
    text-align: center;
    font-family: Gilroy;
    transition:
        color 1s ease-in-out,
        text-shadow 1s ease-in-out;
    color: ${(props) =>
        props.isRewardRedeemed
            ? getTextColor(props.tickerTextColor, props.theme)
            : props.theme?.colors[props.theme?.colorMode]?.positive_Sub};
    ${(props) => {
        const toReward = keyframes`
            0%, 20% { 
                color: ${props.theme.colors[props.theme.colorMode].positive_Sub}; 
                text-shadow: none;
            }
            80%, 100% { 
                color: ${getTextColor(props.tickerTextColor, props.theme)}; 
                text-shadow: 3px 4px 0px #000;
            }
        `;

        const toOriginal = keyframes`
            0%, 20% { 
                color: ${getTextColor(props.tickerTextColor, props.theme)}; 
                text-shadow: 3px 4px 0px #000;
            }
            80%, 100% { 
                color: ${props.theme.colors[props.theme.colorMode].positive_Sub}; 
                text-shadow: none;
            }
        `;

        return (
            props.shouldAnimate &&
            css`
                animation: ${props.isRewardRedeemed ? toReward : toOriginal} 1s cubic-bezier(0.4, 0, 0.2, 1);
                animation-fill-mode: forwards;
            `
        );
    }}
    text-shadow: ${(props) => (props.isRewardRedeemed ? "3px 4px 0px #000" : "none")};
`;

export const CongratsAnimationWrapper = styled.div`
    position: absolute;
    left: 20%;
    top: 5%;
    right: 60%;
    z-index: 999;
    width: 60%;
    height: 60%;
`;

export const CounterAnimation = styled.div`
    display: flex;
    align-items: center;
`;

export const DigitContainer = styled.div`
    position: relative;
    width: ${TICKER_TEXT_CONFIGS.WIDTH};
    height: ${TICKER_TEXT_CONFIGS.HEIGHT};
    overflow: hidden;
`;

export const PunctuationContainer = styled.div`
    position: relative;
    width: ${PUNCTUATION_TEXT_DIMENSIONS.WIDTH};
    height: ${PUNCTUATION_TEXT_DIMENSIONS.HEIGHT};
    overflow: hidden;
`;

export const ScrollingNumber = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    will-change: transform;
`;
